const transitions = {
  cardStandard: 'all 0.2s cubic-bezier(0.65, 0, 0.35, 1)',
};

export { transitions };
